import { render, staticRenderFns } from "./PersonnelInspection.vue?vue&type=template&id=533aeb45&"
import script from "./PersonnelInspection.vue?vue&type=script&lang=js&"
export * from "./PersonnelInspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports